const localApiPort = process.env.REACT_APP_API_PORT || "5000";

export const Baseurl =
  process.env.REACT_APP_API_URL || `http://localhost:${localApiPort}`;

